var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-list"},[_c('list',{attrs:{"fs":_vm.pageFields,"api":"pages","title":"Pages","editLink":"/admin/pages"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }